import { useTranslation } from 'react-i18next';

import { Button } from './Button';
import { Dialog } from './Dialog';
import styles from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
  /** `primary` for confirmations that are not destructive (for example restoring). */
  confirmVariant?: 'danger' | 'primary';
}

/** Confirmation for destructive actions (SECURITY.md §19). */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  pending = false,
  confirmVariant = 'danger',
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog title={title} onClose={onCancel}>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        <Button onClick={onCancel} autoFocus>
          {t('common.cancel')}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} disabled={pending}>
          {confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
